var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgParagraph = function SvgParagraph(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 13.9375H11.9922C12.2656 13.9375 12.5 13.7422 12.5 13.4688V12.5703C12.5 12.2969 12.2656 12.0625 11.9922 12.0625H1.71875C1.44531 12.0625 1.25 12.2969 1.25 12.5703V13.4688C1.25 13.7422 1.44531 13.9375 1.71875 13.9375ZM1.71875 3.9375H11.9922C12.2656 3.9375 12.5 3.74219 12.5 3.46875V2.57031C12.5 2.29688 12.2656 2.0625 11.9922 2.0625H1.71875C1.44531 2.0625 1.25 2.29688 1.25 2.57031V3.46875C1.25 3.74219 1.44531 3.9375 1.71875 3.9375ZM18.125 7.0625H1.875C1.52344 7.0625 1.25 7.375 1.25 7.6875V8.3125C1.25 8.66406 1.52344 8.9375 1.875 8.9375H18.125C18.4375 8.9375 18.75 8.66406 18.75 8.3125V7.6875C18.75 7.375 18.4375 7.0625 18.125 7.0625ZM18.125 17.0625H1.875C1.52344 17.0625 1.25 17.375 1.25 17.6875V18.3125C1.25 18.6641 1.52344 18.9375 1.875 18.9375H18.125C18.4375 18.9375 18.75 18.6641 18.75 18.3125V17.6875C18.75 17.375 18.4375 17.0625 18.125 17.0625Z",
    fill: "#DBE3EB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParagraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paragraph.3710149c.svg";
export { ForwardRef as ReactComponent };